export class InfoForm{
    firstname: string;
    email: string;
    phone_number: string;
    surname: string;
    postcode: number;
    address: string;
    city: string;
    birthdate: string;
    parent_phone: string;
    parent_email: string;

    constructor(){
        this.firstname = null;
        this.surname = null;
        this.postcode = null;
        this.address = null;
        this.city = null;
        this.phone_number = null;
        this.email = null;
        this.birthdate = null;
        this.parent_phone = null;
        this.parent_email = null;
    }
}